module.exports = __webpack_public_path__ + "static/img/login-bg.9959a98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/login-bg.png
// module id = fGuo
// module chunks = 1